export function formatDurationKo(ms: number | null | undefined): string {
  if (ms == null || !Number.isFinite(ms)) return '-'

  const sign = ms < 0 ? '-' : ''
  const totalMinutes = Math.floor(Math.abs(ms) / 60000)
  if (totalMinutes < 1) return `${sign}1분 미만`

  const days = Math.floor(totalMinutes / 1440)
  const hours = Math.floor((totalMinutes % 1440) / 60)
  const minutes = totalMinutes % 60

  if (days > 0) {
    return hours > 0 ? `${sign}${days}일 ${hours}시간` : `${sign}${days}일`
  }
  if (hours > 0) {
    return minutes > 0 ? `${sign}${hours}시간 ${minutes}분` : `${sign}${hours}시간`
  }
  return `${sign}${minutes}분`
}
